import { defineMessages } from 'react-intl';

export default defineMessages({
  marketSize: 'Market size',
  totalBorrowed: 'Total borrowed',

  deposit: 'Deposit',
  borrow: 'Borrow',
  variable: 'Variable',
  stable: 'Stable',
});
